import { alpha } from '@mui/material/styles';
const useAvatarInfoCardStyles = (theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            p: '16px',
            gap: '10px',
            bgcolor: theme.palette.grey[100],
            border: `1px solid ${alpha(theme.palette.grey[500], 0.2)}`,
            borderRadius: theme.spacing(3)
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        textWrapper: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0
        },
        title: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        subtitle: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    };
};
export default useAvatarInfoCardStyles;
